var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_3502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.3549 0 0 14.3549 0 32C0 49.6451 14.3549 64 32 64C49.6451 64 64 49.6451 64 32C64 14.3549 49.6451 0 32 0ZM43.6364 16C46.448 16 48.7273 18.2793 48.7273 21.0909C48.7273 23.9025 46.448 26.1818 43.6364 26.1818C40.8247 26.1818 38.5455 23.9025 38.5455 21.0909C38.5455 18.2793 40.8247 16 43.6364 16ZM20.3636 16C23.1753 16 25.4545 18.2793 25.4545 21.0909C25.4545 23.9025 23.1753 26.1818 20.3636 26.1818C17.552 26.1818 15.2727 23.9025 15.2727 21.0909C15.2727 18.2793 17.552 16 20.3636 16ZM48 52.3636C47.1971 52.3636 46.5455 51.712 46.5455 50.9091C46.5455 42.8887 40.0204 36.3636 32 36.3636C23.9796 36.3636 17.4545 42.8887 17.4545 50.9091C17.4545 51.712 16.8029 52.3636 16 52.3636C15.1971 52.3636 14.5455 51.712 14.5455 50.9091C14.5455 41.2844 22.3753 33.4545 32 33.4545C41.6247 33.4545 49.4545 41.2844 49.4545 50.9091C49.4545 51.712 48.8029 52.3636 48 52.3636Z",
    fill: "#F53D18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_3502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.b444fb248fe6def4fdfc4e5de39233d4.svg";
export { ForwardRef as ReactComponent };